import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InformeRendimentosService {

  constructor( private readonly http: HttpClient ) { }

  public getInformesRendimento(competenceYear:any, companyId: any, pagination: any, tipo: any){
    let page = pagination.page - 1;
    const competence = competenceYear ?? '';
    return this.http.get(`/apiconnect/vale-transporte-reinf/v1/companies/${companyId}/data?competenceYear=${competence}&incomeReportType=${tipo}&page=${page}&size=${pagination.size}`);
  }

  public getEmpresa(companyId: any) {
    return this.http.get(`/apiconnect/vale-transporte-reinf/v1/companies/${companyId}`);
  }

  public getAnoReferencia(): Observable<any>{
    return this.http.get<any>(`/apiconnect/vale-transporte-reinf/v1/reference-year`);
  }

  public getInformeUnico(companyId: number, competenceYear: number) {
    return this.http.get(`/apiconnect/vale-transporte-reinf/v1/companies/${companyId}/file-address?competenceYear=${competenceYear}`);
  }

  public getInformeMassa(companiesId: any[], competenceYear: number) {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/json"
    });

    const body: string = JSON.stringify(companiesId);
    return this.http.post(`/apiconnect/vale-transporte-reinf/v1/batch-files-generation?competenceYear=${competenceYear}`, body, {headers});
  }

  getFileGenerationStatus(idDownload, tipoArquivo: string, idEmpresa: number) {
    const headers = new HttpHeaders().set('api-company-id', idEmpresa.toString());
    return this.http.get<any>(`/apiconnect/core/download-status/${idDownload}/${tipoArquivo}/files`, {headers});
  }

  public dowloadInformePdf(s3Url: string) {
    return this.http.get('/s3Reinf/' + s3Url,  {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  public getDadosInforme(companyId: any){
    return this.http.get(`/apiconnect/vale-transporte-reinf/v1/income-reports/companies/${companyId}/data`);
  }
}
